import { MeterProperties } from '@lib-ui/lib/models/meter-type';
import { CounterDto, MeterType } from '@lib-ui/client';
import { formatObis } from '@lib-ui/lib/functions/format-obis';

export function getCounterDescription(meterType: MeterType | null, counter?: CounterDto) {
  if (!meterType || !counter) {
    return '';
  }
  const meterProperty = MeterProperties.get(meterType);
  const obisCode = counter?.obis?.code ?? '';
  if (meterProperty?.hasObisCode) {
    return `${obisCode} (${formatObis(obisCode)})`;
  }
  return meterProperty?.displayName ?? '';
}
